<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography">
    <p>{{data.confirmationMessage}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>
